import Block from './Block'
import debounce from 'lodash/debounce'
import {gsap} from 'gsap'

export default class Jobs extends Block {
  getElems() {
    this.filtersContainer = this.el.querySelector('.jobs__filters')
    this.countryFilter = this.el.querySelector('#countryFilter')
    this.departmentFilter = this.el.querySelector('#departmentFilter')
    this.searchInput = this.el.querySelector('#jobSearch')
    this.activeFilters = {
      country: '',
      department: '',
      searchTerm: ''
    }
  }

  bindMethods() {
    this._filterJobs = this._filterJobs.bind(this)
    this._initializeFilters = this._initializeFilters.bind(this)
    this._handleSearch = debounce(this._handleSearch.bind(this), 300)
  }

  init() {
    // Hide group headers by default
    gsap.set('.whr-group', {
      display: 'none'
    })

    // Wait for Workable content to load
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          const jobGroups = document.querySelectorAll('.whr-group')

          if (jobGroups.length > 0) {
            this._initializeFilters()
            observer.disconnect()
            break
          }
        }
      }
    })

    this._initializeFilters()

    observer.observe(document.getElementById('whr_embed_hook'), {
      childList: true,
      subtree: true
    })
  }

  _initializeFilters() {
    const deptLogos = {
      'On-Board Electronics': 'https://www.secheron.com/wp-content/uploads/2025/04/HR-logo-200x30-new_align-left.png',
      'Traction Power Systems': 'https://www.secheron.com/wp-content/uploads/2025/04/Logo_Secheron.png',
      'Electrical Safety Solutions': 'https://www.secheron.com/wp-content/uploads/2025/04/Logo_Secheron.png',
      'Common Services': 'https://www.secheron.com/wp-content/uploads/2025/04/SHG-logo-208x30-new_align-left.png'
    };

    // Get unique values from DOM
    const countries = new Set()
    const departments = new Set()

    // Get countries from group headers
    document.querySelectorAll('.whr-group').forEach((group) => {
      countries.add(group.textContent.trim())
    })

    // Get departments from job items
    document.querySelectorAll('.whr-item').forEach((item) => {
      const departmentEl = item.querySelector('.whr-dept')

      if (departmentEl) {
        // Get the text after the <span> element
        const deptText = departmentEl.childNodes[1].textContent.trim()

        departments.add(deptText)

        for (const [deptName] of Object.entries(deptLogos)) {
          if (departmentEl.textContent.includes(deptName)) {
            departmentEl.dataset.deptName = deptName.toLowerCase().replace(/\s+/g, '-');
          }
        }
        // Replace "Department:" with "Business Units:" in job grid
        const labelEl = departmentEl.querySelector('span');

        if (labelEl && labelEl.textContent.trim() === 'Department:') {
          labelEl.textContent = 'Business Unit:';
        }
      }
    })

    // Replace "All Departments" with "All Business Units" in filter
    const filterOption = document.querySelector('#departmentFilter option[value=""]');

    if (filterOption && filterOption.textContent.trim() === 'All Departments') {
      filterOption.textContent = 'All Business Units';
    }

    // Populate filters
    this._populateSelect(this.countryFilter, countries)
    this._populateSelect(this.departmentFilter, departments)

    // Initialize event listeners
    this.events()
  }

  _populateSelect(select, values) {
    Array
      .from(values)
      .sort()
      .forEach((value) => {
        const option = document.createElement('option')

        option.value = value
        option.textContent = value
        select.appendChild(option)
      })
  }

  events() {
    // Country filter change
    this.countryFilter.addEventListener('change', (e) => {
      this.activeFilters.country = e.target.value
      this._filterJobs()
    })

    // Department filter change
    this.departmentFilter.addEventListener('change', (e) => {
      this.activeFilters.department = e.target.value
      this._filterJobs()
    })

    // Search input with debounce
    this.searchInput.addEventListener('input', this._handleSearch)
  }

  _handleSearch() {
    this.activeFilters.searchTerm = this.searchInput.value.toLowerCase()
    this._filterJobs()
  }

  _filterJobs() {
    // Get all job groups and their associated items
    const groups = document.querySelectorAll('.whr-group')

    groups.forEach((group) => {
      const jobsList = group.nextElementSibling
      const jobs = jobsList.querySelectorAll('.whr-item')
      let hasVisibleJobs = false

      // Filter jobs within this group
      jobs.forEach((job) => {
        const department = job.querySelector('.whr-dept')?.childNodes[1].textContent.trim() || ''
        const jobText = job.querySelector('.whr-title').textContent.toLowerCase()

        const matchesCountry = !this.activeFilters.country || group.textContent.trim() === this.activeFilters.country
        const matchesDepartment = !this.activeFilters.department || department === this.activeFilters.department
        const matchesSearch = !this.activeFilters.searchTerm || jobText.includes(this.activeFilters.searchTerm)

        if (matchesCountry && matchesDepartment && matchesSearch) {
          job.style.display = ''
          hasVisibleJobs = true
        } else {
          job.style.display = 'none'
        }
      })

      // Show/hide the job list based on whether it has visible jobs
      jobsList.style.display = hasVisibleJobs ? 'grid' : 'none'
    })
  }
}
